const modules = {}
const files = require.context('./modules', false, /\.js$/)
files.keys().forEach(key => {
  const fileName = key.replace(/(\.\/|\.js)/g, '')
  const keyName = fileName.replace(/-(\w)/g, (all, letter) => letter.toUpperCase())
  modules[keyName] = files(key).default
})
export default modules
